import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin, PlaneTakeoff } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed! Check your inbox for our next travel dispatch.");
      setEmail("");
    } catch { toast.error("Please try again."); }
  };

  return (
    <footer data-testid="site-footer" className="relative mt-24 bg-[#0B1120] text-slate-200">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-10 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="w-11 h-11 rounded-2xl btn-gold flex items-center justify-center"><PlaneTakeoff className="w-6 h-6"/></span>
            <div>
              <div className="font-[Playfair_Display] text-2xl font-bold text-white">Your Trips</div>
              <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37]">Pack &amp; Go</div>
            </div>
          </div>
          <p className="mt-5 text-slate-400 max-w-md">
            Crafting handpicked luxury journeys across India and beyond. From misty hills to sunlit beaches — we handle every detail so you can simply pack &amp; go.
          </p>
          <form onSubmit={subscribe} data-testid="newsletter-form" className="mt-6 flex gap-2 max-w-md">
            <input
              data-testid="newsletter-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email" required placeholder="your@email.com"
              className="flex-1 rounded-full bg-white/10 border border-white/20 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37]"
            />
            <button data-testid="newsletter-submit" className="px-5 py-3 rounded-full btn-gold text-sm">Subscribe</button>
          </form>
        </div>

        <div>
          <h4 className="text-white text-lg mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {[["Home","/"],["About","/about"],["Packages","/packages"],["Gallery","/gallery"],["Blog","/blog"],["Contact","/contact"]].map(([l,u]) =>
              <li key={u}><Link to={u} className="hover:text-[#D4AF37]">{l}</Link></li>
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg mb-4">Popular Destinations</h4>
          <ul className="space-y-2 text-sm">
            {["kashmir","ladakh","kerala","spiti-valley","bhutan","andaman"].map((s) =>
              <li key={s}><Link to={`/packages/${s}`} className="hover:text-[#D4AF37] capitalize">{s.replace('-',' ')}</Link></li>
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-lg mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><Phone className="w-4 h-4 text-[#D4AF37] mt-1"/> <a href="tel:+919891782652">+91 9891782652</a></li>
            <li className="flex items-start gap-2"><Mail className="w-4 h-4 text-[#D4AF37] mt-1"/> <a href="mailto:Himanshu@yourtrips.co.in">Himanshu@yourtrips.co.in</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-[#D4AF37] mt-1"/> New Delhi, India</li>
          </ul>
          <div className="flex gap-3 mt-5">
            <a data-testid="social-instagram" href="https://instagram.com/yourtrips" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full flex items-center justify-center bg-white/10 hover:bg-[#D4AF37] hover:text-[#0B1120]"><Instagram className="w-4 h-4"/></a>
            <a data-testid="social-facebook" href="https://www.facebook.com/share/19Js5xWC6R/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full flex items-center justify-center bg-white/10 hover:bg-[#D4AF37] hover:text-[#0B1120]"><Facebook className="w-4 h-4"/></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} Your Trips — Pack &amp; Go. Crafted with love in New Delhi.
      </div>
    </footer>
  );
}
